import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import chakraTheme from "./constants/chakraTheme";

const geoUrl = window.location.origin + "/locations/world-110m.json";

// const markers = [
//   {
//     markerOffset: -30,
//     name: "Buenos Aires",
//     coordinates: [-58.3816, -34.6037],
//   },
//   { markerOffset: 15, name: "Boston", coordinates: [-68.1193, -16.4897] },
//   { markerOffset: 15, name: "Brasilia", coordinates: [-47.8825, -15.7942] },
//   { markerOffset: 15, name: "Santiago", coordinates: [-70.6693, -33.4489] },
//   { markerOffset: 15, name: "Bogota", coordinates: [-74.0721, 4.711] },
//   { markerOffset: 15, name: "Quito", coordinates: [-78.4678, -0.1807] },
//   { markerOffset: -30, name: "Georgetown", coordinates: [-58.1551, 6.8013] },
//   { markerOffset: -30, name: "Asuncion", coordinates: [-57.5759, -25.2637] },
//   { markerOffset: 15, name: "Paramaribo", coordinates: [-55.2038, 5.852] },
//   { markerOffset: 15, name: "Montevideo", coordinates: [-56.1645, -34.9011] },
//   { markerOffset: 15, name: "Caracas", coordinates: [-66.9036, 10.4806] },
//   { markerOffset: 15, name: "Lima", coordinates: [-77.0428, -12.0464] },
// ];

const WaitTimesMap = ({ locations = [] }) => {
  return (
    <ComposableMap
      projection="geoAzimuthalEqualArea"
      projectionConfig={{
        rotate: [100, -40, 0],
        scale: 600,
      }}
      // width={500}
      // height={500}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies
            .filter((d) => d.properties.REGION_UN === "Americas")
            .map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={chakraTheme.colors.gray[300]}
                stroke={chakraTheme.colors.gray[500]}
                strokeWidth={0.5}
              />
            ))
        }
      </Geographies>
      {locations.map(({ name, coordinates, markerOffset, waitTimeDays }) => {
        if (coordinates?.length) {
          let color;
          if (waitTimeDays > 365 / 2) {
            color = "salmon";
          } else if (waitTimeDays > 30) {
            color = "yellow";
          } else {
            color = "lightgreen";
          }
          return (
            <Marker key={name} coordinates={[coordinates[1], coordinates[0]]}>
              <g
                fill={color}
                // stroke="#FF5533"
                // transform="translate(-12, -24)"
              >
                <circle cx="0" cy="0" r="6" opacity={0.5} />
              </g>
              {/* <text
                textAnchor="middle"
                y={0}
                style={{ fontFamily: "system-ui", fill: "#5D5A6D" }}
              >
                {name}
              </text> */}
            </Marker>
          );
        } else {
          return null;
        }
      })}
    </ComposableMap>
  );
};

export default WaitTimesMap;
